import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Accordion } from "./components/setting-accordion";
import { Input } from "./components/input";
import { SaveButton } from "./components/save-button";
import SettingIcon from "../../../../../../images/settings-icons/setting-email.png";
import { modifyUser } from "../../../../../../api";

const Row = styled.div`
  display: flex;
  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

const UpdateEmail = (props) => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState(props.email);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setEmail(props.email);
  }, [props.email]);

  const isValidEmail = () => {
    // eslint-disable-next-line
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email)) return false;
    else return true;
  };

  const handleSubmit = () => {
    let mods = {};
    mods["email_address"] = email;
    
    if (isValidEmail()) {
      setLoading(true);

      modifyUser(props.userId, props.portalId, mods)
        .then((res) => {
          setLoading(false);
          setShow(false);
          props.loadPortalAccount();
          props.openSnackbar("Your email has been updated", false)
        })
        .catch((err) => {
          setLoading(false);
          props.openSnackbar("An error has occured", false)
        });
    } else {
      props.openSnackbar("Please enter a valid email address", true)
    }
  };

  const handleReset = () => {
    setEmail(props.email);
  }

  const disabled = email === props.email || email === "";

  return (
    <>
      <Accordion
        show={show}
        setShow={setShow}
        handleReset={handleReset} 
        settingName="Email"
        description="Please use your account email address"
        icon={SettingIcon}
        currentSetting={props.email}
        alternateColor
      >
        <Row>
          <Input onChange={(e) => setEmail(e.target.value)} value={email} type="email" />
          <SaveButton
            disabled={disabled}
            isLoading={isLoading}
            onClick={handleSubmit}
          />
        </Row>
      </Accordion>
    </>
  );
};

export default UpdateEmail;
